export const hashCode = (s: string | undefined | null): number => {
  if (s === null || s === undefined) {
    return 0;
  }
  let hash = 0;
  for (let i = 0; i < s.length; ++i)
    hash = Math.imul(31, hash) + s.charCodeAt(i);
  return Math.abs(hash | 0);
};
